// Login.jsx
import React, { useEffect, useState } from 'react';
import '../../App.css';
import DeskImage from '../../desk.svg';
import { useNavigate } from 'react-router-dom';

import AuthService from '../../services/AuthService';
import { useAuth } from '../../provider/authProvider';
import PreloadFetch from '../../components/PreloadFetch';

function Login() {
    const {
        setToken,
        setUser,
        setName,
        setFullName,
        setRol,
        applySede,
        showSedeLoginNotice,
    } = useAuth();

    const [access, setAccess] = useState({ username: '', password: '' });
    const [loginMsg, setLoginMsg] = useState('');
    const [preload, setPreload] = useState(false);
    const navigate = useNavigate();

    const handleLogin = async (e) => {
        e.preventDefault();

        if (access.username.trim() === '') { setLoginMsg('Ingrese el usuario'); return; }
        if (access.password.trim() === '') { setLoginMsg('Ingrese la contraseña'); return; }

        try {
            setPreload(true);
            const auth = await AuthService.login(access);

            if (auth && auth.token) {
                setToken(auth.token);
                setUser(auth.user);
                setName(auth.name);
                setFullName?.(auth.fullName ?? auth.name ?? null);
                setRol?.(auth.rol != null ? String(auth.rol) : null);
                applySede?.({
                    sedeId: auth.sedeId,
                    sedeName: auth.sedeName,
                    sedeLocation: auth.sedeLocation,
                });
                setLoginMsg('');

                const rolStr = String(auth.rol ?? '');

                if (rolStr === '3') {
                    // Si el asesor ya tiene sede asignada desde Usuarios, entra directo.
                    if (auth.sedeId != null) {
                        showSedeLoginNotice?.({
                            fullName: auth.fullName ?? auth.name,
                            name: auth.name,
                            sedeId: auth.sedeId,
                            sedeName: auth.sedeName,
                            sedeLocation: auth.sedeLocation,
                        });
                        navigate('/evaluation-system', { replace: true });
                        return;
                    }

                    // Compatibilidad para asesores legacy que todavía no tengan sede asignada.
                    navigate('/select-branch', { replace: true });
                    return;
                }

                navigate('/evaluation-system', { replace: true });
            } else {
                setLoginMsg('Credenciales incorrectas');
            }
        } catch (err) {
            console.error(err);
            setLoginMsg('Error al iniciar sesión');
        } finally {
            setPreload(false);
        }
    };

    useEffect(() => {
        const getFormsControl = document.getElementsByClassName('form-control');
        Array.from(getFormsControl).forEach(element => {
            element.addEventListener('input', (elem) => {
                const parentFormGroup = elem.target.closest('.form-group');
                if (elem.target.value) parentFormGroup.classList.add('field--not-empty');
                else parentFormGroup.classList.remove('field--not-empty');
            });
        });
        return () => {
            Array.from(getFormsControl).forEach(element => {
                element.removeEventListener('input', () => {});
            });
        };
    }, []);

    return (
        <>
            {preload && <PreloadFetch />}

            <div className="content">
                <div className="container pb-4">
                    <div className="row">
                        <div className="col-md-6">
                            <img src={DeskImage} alt="Image" className="img-fluid" />
                        </div>

                        <div className="col-md-6 contents">
                            <div className="row justify-content-center">
                                <div className="col-md-8">
                                    <div className="mb-4">
                                        <h3>Sign In to Moviles Pay</h3>
                                        <p className="mb-4">
                                            Somos MovilPay, nuestra confianza es la tuya, te ayudamos a estar conectado con la tecnología.
                                        </p>
                                    </div>

                                    <form onSubmit={handleLogin}>
                                        {loginMsg && (<div style={{ color: 'red' }}>{loginMsg}</div>)}

                                        <div className="form-group first">
                                            <label htmlFor="username">Username</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="username"
                                                autoComplete="off"
                                                onChange={e => setAccess({ ...access, username: e.target.value })}
                                            />
                                        </div>

                                        <div className="form-group last mb-4">
                                            <label htmlFor="password">Password</label>
                                            <input
                                                type="password"
                                                className="form-control"
                                                id="password"
                                                onChange={e => setAccess({ ...access, password: e.target.value })}
                                            />
                                        </div>

                                        <button type="submit" className="btn btn-block btn-primary">Log In</button>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Login;
